import { ProcessDeUtil } from "../../domain/process-de-util";

export class SmsMessageTemplate { 
    code: string;

    content: string;

    smsMessageVariables: Array<SmsMessageVariable>;
    constructor() { 
        this.smsMessageVariables = new Array();
    }
}

export class SmsMessageVariable { 
    constructor() { 
        this.id = ProcessDeUtil.createNM();
    }
    id: string;
    code: string;
    value: string
    tag = 'expression';
}